var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00547 7.99673C6.87398 7.99749 6.74364 7.97229 6.62191 7.92257C6.50019 7.87285 6.38947 7.7996 6.29612 7.707L0.301634 1.71252C0.113503 1.52439 0.0078125 1.26923 0.0078125 1.00317C0.0078125 0.737112 0.113503 0.481952 0.301634 0.293821C0.489764 0.105691 0.744924 0 1.01098 0C1.27704 0 1.5322 0.105691 1.72033 0.293821L7.00547 5.58895L12.2906 0.303812C12.4817 0.140137 12.7276 0.0546088 12.979 0.064321C13.2305 0.0740332 13.469 0.17827 13.6469 0.356201C13.8248 0.534132 13.9291 0.772651 13.9388 1.0241C13.9485 1.27554 13.863 1.52139 13.6993 1.71252L7.70482 7.707C7.51873 7.89158 7.26756 7.99563 7.00547 7.99673Z",
    fill: "#182138"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdown-icon.c73e8f6e0eec429784ef1a894400feb3.svg";
export { ForwardRef as ReactComponent };